/**
 * An advertiser as a chooser shows it: the id alongside the name, because the id is what
 * anyone matching against the platform actually has in hand — a partner can hold hundreds
 * of advertisers, and names among them repeat.
 *
 * Collapsed to just the id where that is all the platform gave us, so nothing reads
 * "907583025 (907583025)".
 */
export function advertiserLabel(advertiser: { id: string; name: string }): string {
  return advertiser.name === advertiser.id
    ? advertiser.id
    : `${advertiser.name} (${advertiser.id})`;
}
